import api from "@/services/api";
/****************
     * Apps builder
     ****************/

export default {
  getApps() {
    return api.get(`/api/v1/apps`);
  },

  getApp() {
    return api.get(`/api/v1/app`);
  },

  updateApp(appData) {
    return api.put(`/api/v1/app`, appData);
  },

  deleteApp(appId) {
    return api.delete(`/api/v1/apps?app_id=${appId}`);
  }
};
